import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { useSite, whatsappLink, useWhatsAppNumber, defaultWhatsAppText } from "@/context/SiteContext";

export const WhatsAppButton = ({ text, className = "", testId = "whatsapp-button", children }) => {
  const number = useWhatsAppNumber();
  const { pathname } = useLocation();
  const href = whatsappLink(number, text || defaultWhatsAppText(pathname));
  const onClick = (e) => {
    if (href) return;
    e.preventDefault();
    toast("WhatsApp isn't connected yet — please use the enquiry form and we'll reply quickly.");
  };
  return (
    <a href={href || "#contact"} target={href ? "_blank" : undefined} rel="noopener noreferrer" onClick={onClick}
      data-testid={testId} className={`inline-flex items-center gap-3 ${className}`}>
      <MessageCircle size={16} />
      {children || "WhatsApp us"}
    </a>
  );
};

export const FloatingWhatsApp = () => {
  const number = useWhatsAppNumber();
  const { pathname } = useLocation();
  const href = whatsappLink(number, defaultWhatsAppText(pathname));
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" data-testid="floating-whatsapp-button"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-white text-gw-onwhite border border-gw-ground/20 flex items-center justify-center shadow-lg transition-transform duration-200 hover:-translate-y-1">
      <MessageCircle size={22} />
    </a>
  );
};

export const ContactSection = ({ defaultCompany }) => {
  const { settings } = useSite();
  return (
    <section id="contact" data-testid="contact-section" className="bg-gw-ground text-white py-24 md:py-32 scroll-mt-16">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12">
        <div className="min-w-0">
          <p className="lab text-gw-mist mb-4">Contact</p>
          <h2 className="lux gw-h2">Open a conversation.</h2>
          <p className="gw-body mt-6 max-w-md text-gw-pale">
            Buying, leasing, investing, building or sourcing for a vessel — tell us what you need and the right team will reply.
          </p>
          <WhatsAppButton testId="contact-whatsapp-button"
            className="mt-8 lab bg-white text-gw-ground px-6 py-4 transition-colors duration-200 hover:bg-gw-mist" />
          <dl className="mt-10 space-y-3 lab text-gw-pale" data-testid="contact-details">
            {settings.phone && <div><dt className="opacity-60">Phone</dt><dd className="text-white normal-case tracking-normal text-base mt-1"><a href={`tel:${settings.phone}`}>{settings.phone}</a></dd></div>}
            {settings.email && <div><dt className="opacity-60">Email</dt><dd className="text-white normal-case tracking-normal text-base mt-1"><a href={`mailto:${settings.email}`}>{settings.email}</a></dd></div>}
            {settings.address && <div><dt className="opacity-60">Office</dt><dd className="text-white normal-case tracking-normal text-base mt-1">{settings.address}</dd></div>}
          </dl>
        </div>
        <EnquiryForm defaultCompany={defaultCompany} />
      </div>
    </section>
  );
};
